import { lazy, Suspense, useState, useEffect } from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import tradeMultiRequestModalReducer from './reducer';
import thunk from 'redux-thunk';

const store = createStore(tradeMultiRequestModalReducer, applyMiddleware(thunk));

export function TradeMultiRequestModalLoader({ load, ...props }) {
    const [LazyModal, setLazyModal] = useState(null);
    useEffect(() => {
        if (load && !LazyModal) {
            setLazyModal(
                lazy(() =>
                    import(
                        /* webpackChunkName: "TradeMultiRequestModal" */ './TradeMultiRequestModalRenderer'
                    )
                )
            );
        }
    }, [LazyModal, load]);
    return (
        LazyModal && (
            <Suspense fallback={''}>
                <Provider store={store}>
                    <LazyModal {...props} />
                </Provider>
            </Suspense>
        )
    );
}

TradeMultiRequestModalLoader.propTypes = {
    load: PropTypes.bool,
};
